import * as PolicyConstants from './policy.constants';

export default PolicyConstants;
